import { render, staticRenderFns } from "./SimpleTerminalCard.vue?vue&type=template&id=73b40e9b&scoped=true&"
import script from "./SimpleTerminalCard.vue?vue&type=script&lang=js&"
export * from "./SimpleTerminalCard.vue?vue&type=script&lang=js&"
import style0 from "./SimpleTerminalCard.vue?vue&type=style&index=0&id=73b40e9b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b40e9b",
  null
  
)

export default component.exports